import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/home/Index'),
    },
    {
      path: '/blog',
      name: 'Blog',
      component: () => import(/* webpackChunkName: "blog" */ '@/views/blog/Index'),
    },
    {
      path: '/posts/:slug',
      name: 'Post',
      component: () => import(/* webpackChunkName: "posts" */'@/views/posts/Index'),
    },
    {
      path: '/projects',
      name: 'Projects',
      component: () => import(/* webpackChunkName: "projects" */'@/views/projects/Index'),
    },
  ],
})

export default router
